/**
 * Shared formatting helpers.
 */

/**
 * Format a phone number as (XXX) XXX-XXXX when it has exactly 10 digits;
 * otherwise return the original string unchanged.
 * @param {string} phoneNumberString
 * @returns {string}
 */
export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  if (cleaned.length !== 10) {
    return phoneNumberString;
  }
  return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6, 10)}`;
};

/**
 * Convert a 24-hour "HH:MM" time string (as produced by <input type="time">)
 * into a 12-hour "h:MM AM/PM" string. Returns the input unchanged if it can't
 * be parsed, so already-formatted or empty values pass through safely.
 * @param {string} timeString
 * @returns {string}
 */
export const formatTime12Hour = (timeString) => {
  if (typeof timeString !== 'string') {
    return timeString;
  }
  const match = timeString.match(/^(\d{1,2}):(\d{2})/);
  if (!match) {
    return timeString;
  }
  let hours = parseInt(match[1], 10);
  const minutes = match[2];
  if (Number.isNaN(hours) || hours > 23) {
    return timeString;
  }
  const period = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return `${hours}:${minutes} ${period}`;
};
